import { Constants } from "../constants/constants";

export class UserInfo{
    gId: string = '';
    fullName: string = '';
    email: string = '';
    roleId: number = 0;
    isReviewer: boolean = false;
    countryCode: string = '';
    accessLevel: number = 0;
    locale: string = Constants.DEFAULT_LOCALE;
}
